<div class="app-pos-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <div class="title-main">ยกเลิก{{ dialogTitle }}</div>
      <div class="title-description">กรุณาเลือกเหตุผลในการยกเลิก{{ dialogTitle }}</div>
    </div>
    <div class="header-action">
      <button type="button" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dialog-body">
    <form [formGroup]="dialogForm" (submit)="onSubmit()">
      <div class="form-container">
        <div class="row">
          <div class="col-12" *ngIf="showErrorMessage">
            <p class="text-danger text-center">กรุณากรอกข้อมูลให้ครบ</p>
          </div>
          <div class="col-12 mb-2">
            <p class="p-text-title">เหตุผล</p>
          </div>

          <ng-container formArrayName="cancel_remark_list">
            <ng-container *ngFor="let item of getCancelBillRemarkControl.controls; index as i">
              <ng-container [formGroupName]="i">
                <div class="col-12">
                  <mat-checkbox formControlName="is_checked" color="accent" (change)="onCancelBillRemarkChange(i)">{{
                    getCancelBillRemarkControl.controls[i]['value']['name']
                  }}</mat-checkbox>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- <div class="col-12">
            <mat-checkbox formControlName="customer_cancel" color="accent">ลูกค้าขอยกเลิกรายการที่สั่ง</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="staff_issue" color="accent">พนักงานใส่ข้อมูลผิดพลาด</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="customer_change" color="accent">ลูกค้าขอเปลี่ยนราคา</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="other" color="accent">อื่น</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-form-field appearance="standard">
              <mat-label>เหตุผลอื่นๆ</mat-label>
              <textarea matInput formControlName="other_text"></textarea>
              <mat-error *ngIf="getFormControl['other_text'].errors?.['required']">กรุณากรอกข้อมูล</mat-error>
            </mat-form-field>
          </div> -->
          <div class="col-12 mt-4 mb-2">
            <p class="p-text-title">คืนสินค้า</p>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="is_return_stock" color="accent">คืนสต็อก</mat-checkbox>
          </div>
          <div class="col-12">
            <mat-checkbox formControlName="is_not_return_stock" color="accent">ไม่คืนสต็อก</mat-checkbox>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <button type="button" mat-raised-button (click)="close()">ปิด</button>
        <button type="submit" mat-raised-button color="accent">ยืนยัน</button>
      </div>
    </form>
  </div>
</div>
